import PropTypes from 'prop-types';
import {useCallback, useEffect, useState} from 'react';

import {ControlledCollapse, Separator} from '../../../ui';
import AttachmentsLists from '../../../ui/attachmentsLists/components/AttachmentsLists';
import css from '../../styles/Video.module.css';
import TopicTitle from './TopicTitle';
import Video from './Video';

const CollapsedTopic = ({
  topic,
  onTopicClick,
  selectedVideoId,
  onTopicVideoClick,
  isOpenByDefault,
  onTopicAttachmentClick,
  contentCreator,
  currentTopic,
}) => {
  const [isOpen, setOpen] = useState(isOpenByDefault);

  useEffect(() => {
    if (isOpenByDefault) {
      setOpen(true);
    }
  }, [isOpenByDefault]);

  const getVideoListNode = useCallback(
    (videos) => {
      if (!videos.length) return null;

      return (
        <div className={css.videoList}>
          {videos.map((video, index) => {
            return (
              <>
                <Video
                  contentCreator={contentCreator}
                  key={video.id}
                  isActive={selectedVideoId === video.id}
                  duration={video.duration}
                  image={video.previewImage}
                  title={video.title}
                  id={video.id}
                  onTopicVideoClick={() => {
                    onTopicVideoClick(video, topic.id);
                  }}
                />
                {videos.length - 1 !== index && (
                  <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
                )}
              </>
            );
          })}
        </div>
      );
    },
    [topic, selectedVideoId]
  );

  return (
    <ControlledCollapse
      isGrayOnOpen={currentTopic.id !== topic.id}
      innerPadding={ControlledCollapse.INNER_PADDING.NO_PADDING}
      isOpen={isOpenByDefault || isOpen || currentTopic.id === topic.id}
      toggleIsOpen={() => setOpen(!isOpen)}
      isCollapseOnArrow
      headTitle={
        <TopicTitle
          duration={topic.videosDuration}
          title={topic.title}
          videoCount={topic.videosCount}
          onClick={() => onTopicClick(topic.id)}
        />
      }
    >
      <div>{getVideoListNode(topic.videos)}</div>
      <AttachmentsLists
        files={topic.files}
        links={topic.links}
        isSquare
        onAttachmentClick={onTopicAttachmentClick}
      />
    </ControlledCollapse>
  );
};

CollapsedTopic.propTypes = {
  topic: PropTypes.object.isRequired,
  onTopicClick: PropTypes.func.isRequired,
  selectedVideoId: PropTypes.number.isRequired,
  onTopicVideoClick: PropTypes.func.isRequired,
  onTopicAttachmentClick: PropTypes.func.isRequired,
  isOpenByDefault: PropTypes.bool.isRequired,
  contentCreator: PropTypes.object.isRequired,
};

export default CollapsedTopic;
